import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-ui-loading',
    standalone: true,
    template: `
    <div class="flex flex-col items-center justify-center gap-3 py-16 text-rose-400">
      <div class="w-10 h-10 rounded-full border-4 border-rose-100 animate-spin" style="border-top-color: var(--bg-main);"></div>
      <p class="text-sm font-semibold">{{ label }}</p>
    </div>
    `
})
export class UiLoadingComponent {
    @Input() label = 'Cargando...';
}
